import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class CombinedAssociationsPopupListenerService {
	onOpen$: Observable<void>;
	onClose$: Observable<void>;
	onChange$: Observable<void>;

	private onOpen: Subject<void> = new Subject<void>();
	private onClose: Subject<void> = new Subject<void>();
	private onChange: Subject<void> = new Subject<void>();

	constructor() {
		this.onOpen$ = this.onOpen.asObservable();
		this.onClose$ = this.onClose.asObservable();
		this.onChange$ = this.onChange.asObservable();
	}

	triggerOpen(): void {
		this.onOpen.next();
	}

	triggerClose(): void {
		this.onClose.next();
	}

	triggerChange(): void {
		this.onChange.next();
	}
}
